import { t } from "../../i18n";
import { Search } from "lucide-react";
import { CopyButton } from "../CopyButton";
import { asRecord } from "./ToolResultView.utils";
import { Card } from "./WorkspaceResultCard";
import { Heading } from "./WorkspaceResultHeading";
import {
  recordValue,
  payload,
  shellOutput,
  text,
} from "./WorkspaceResult.utils";

export function SearchResult({
  input,
  result,
}: {
  input: Record<string, unknown>;
  result: unknown;
}) {
  const lines = shellOutput(result)
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
  const raw = recordValue(payload(result));
  const matches = Array.isArray(raw.matches)
    ? raw.matches
    : Array.isArray(raw.results)
      ? raw.results
      : lines;
  return (
    <Card tone="violet">
      <Heading
        icon={
          <Search size={16} className="text-violet-700 dark:text-violet-300" />
        }
      >
        {t("Search matches")}
      </Heading>
      <div className="mt-1 text-xs text-stone-500">
        {text(input.query) || t("Workspace search")} ·{" "}
        {t("{{count}} matches", { count: matches.length })}
      </div>
      {matches.length ? (
        <div className="mt-3 divide-y divide-violet-200 overflow-hidden rounded-xl border border-violet-200 dark:divide-violet-900/50 dark:border-violet-900/60">
          {matches.slice(0, 100).map((match, index) => {
            const value = asRecord(match);
            const path = text(value?.path) || text(value?.file) || "";
            const line = value?.line ?? value?.lineNumber;
            const content =
              text(value?.content) ||
              text(value?.text) ||
              (typeof match === "string" ? match : JSON.stringify(match));
            return (
              <div
                key={index}
                className="px-3 py-2 font-mono text-[11px] leading-5"
              >
                <div className="flex gap-2">
                  <span className="shrink-0 text-violet-700 dark:text-violet-300">
                    {path || "match"}
                    {line !== undefined ? `:${String(line)}` : ""}
                  </span>
                  {path && <CopyButton value={path} label={t("Copy path")} />}
                </div>
                <div className="break-words text-stone-600 dark:text-stone-300">
                  {content}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <p className="mt-3 text-xs text-stone-500">{t("No matches found")}</p>
      )}
    </Card>
  );
}
